module.exports = __webpack_public_path__ + "static/media/innerLogo.581cd02a.png";